module.exports = __webpack_public_path__ + "static/media/Frame619(1).9b71d485.png";